/**
 * Constantes de validación para formularios
 */

/**
 * Longitudes de documentos de identidad por país
 */
export const DOCUMENT_LENGTHS = {
  AR_CUIL_LENGTH: 11,
  DO_CEDULA_LENGTH: 11,
} as const;

/**
 * Longitudes de otros campos comunes
 */
export const FIELD_LENGTHS = {
  PHONE_LENGTH: 10,
} as const;

